import activityRoutes from './activity.routes';

import activitySaveController from './controllers/activity.save.controller';
import activityFormController from './controllers/activity.form.controller';
import activityListController from './controllers/activity.list.controller';

import activityListComponent from './components/activity.list.component';
import activityFormComponent from './components/activity.form.component';
import activitySaveComponent from './components/activity.save.component';

import activitiesService from './services/activities.service';

let activityModule = angular.module('spabooker.activity', ['spabooker.base'])
    .config(activityRoutes)

    .controller('activitySaveController', activitySaveController)
    .controller('activityFormController', activityFormController)
    .controller('activityListController', activityListController)

    .component('activityList', activityListComponent)
    .component('activityForm', activityFormComponent)
    .component('activitySave', activitySaveComponent)

    .factory('activitiesService', activitiesService)
    ;

export default activityModule.name;



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/activity/index.js